import React, { useState, useEffect, useContext } from 'react';
import { Detail as DetailComponent, Confirm, useDrawer, SplitButton, useFormatter } from 'src/mtska-frontend-app-component';
import { useDataProvider } from 'src/mtska-frontend-data-provider';
import { useTranslation } from 'react-i18next';
import { AppContext } from 'src/mtska-frontend-app-scaffolding';
import { useLoadOne } from "src/mtska-frontend-data-provider/hooks/useLoadOne.hooks";

const dataProviderName = 'calendars/carcalendar';

const Detail = (params) => {
    const { t } = useTranslation();
    const { activate, close: closeDrawer } = useDrawer();
    const { userCapabilities, existingModules } = useContext(AppContext);
    const { formatDate } = useFormatter();

    // DATA PROVIDER
    const { item, save, loadOne, destroy, errorMessage, errors, saving, success, reloadCounter } = useDataProvider(dataProviderName, params.multipart);

    const { modelName, detailConfig } = existingModules[dataProviderName]

    useLoadOne({ loadOne, params, reloadCounter })

    const [editing, setEditing] = useState(false)

    const handleSave = (data) => {
        save({ ...data, filters: params.filters }).then((data) => params.handleClose(params.uid, data.item.data)).catch(() => console.error('catch handleSave'));
    }

    const [confirmDelete, setConfirmDelete] = useState()
    const handleDelete = (id) => {
        setConfirmDelete(
            <Confirm
                oklabel={t("Delete")}
                okcallable={() => {
                    destroy && destroy(id);
                    closeDrawer();
                }}
                kolabel={t("Cancel")}
                kocallable={() => { setConfirmDelete(null) }}
                title={t("Item elimination")}>
                {t("Are you sure to remove this element?")}
            </Confirm>
        );
    }

    return (
        <>
            <DetailComponent
                disableDetailConfigOverride={true}
                values={{
                    status: item?.data?.status,
                    bookabilityStart_at: item?.data?.bookabilityStart_at,
                    bookabilityEnd_at: item?.data?.bookabilityEnd_at,
                    minimumDaysBookable: item?.data?.minimumDaysBookable,
                    maximumDaysBookable: item?.data?.maximumDaysBookable,
                    recoveryTimeAtReenter: item?.data?.recoveryTimeAtReenter,
                    requiredStartDay: item?.data?.requiredStartDay,
                    timeframePickup: item?.data?.timeframePickup,
                    timeframeReenter: item?.data?.timeframeReenter,
                    car: item?.data?.car,
                    legalEntity: item?.data?.legalEntity,
                }}
                modelName={modelName}
                detailConfig={detailConfig}
                dataProviderName={dataProviderName}
                onEditing={setEditing}
                save={handleSave}
                saving={saving}
                errors={errors}
                errorMessage={errorMessage}
                canSave={userCapabilities && userCapabilities[dataProviderName + '.edit']}
                title={item?.data?.car ? t('Calendar for vehicle {{plate}}', {plate:item?.data?.car?.plate}) : t('New calendar')}
                subtitle={item?.data?.scope && item?.data?.scope}
                rightButtons={[
                    <SplitButton
                        actions={[
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.delete'],
                                icon: "faTrash",
                                label: t('Delete'),
                                onClick: () => { handleDelete(item.data.id); }
                            },
                            {
                                disabled: userCapabilities && !userCapabilities[dataProviderName + '.log'],
                                icon: "faClipboardList",
                                label: t('Log'),
                                onClick: () => {
                                    activate('wizards/log', {
                                        model: dataProviderName,
                                        entityId: item.data.id,
                                        detailStack: params.detailStack ?? {},
                                        title: t("Item elimination")
                                    });
                                }
                            },

                        ]}
                    />
                ]}
                {...params}
            />

            {confirmDelete}
        </>
    )
}

export default Detail;



